<template>
  <div>
    <label v-if="label" class="block text-xs font-medium mb-1 text-growth-600">{{ label }}</label>
    <input
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :type="type"
      :placeholder="placeholder"
      class="border border-growth-50 rounded px-2 py-1.5 text-sm focus:ring-2 focus:ring-growth-tangerine focus:border-growth-tangerine transition-all hover:border-growth-600"
    />
  </div>
</template>

<script>
export default {
  name: 'FilterInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
}
</script>
